import React from 'react';
import styles from './Modal.module.scss';
import { useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import { axiosBackend } from '../../../axios/Axios.js';
import "./Modal.css"
import { getToken } from "../../../services/auth";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';
import Dropzone from "react-dropzone-uploader";
import "react-dropzone-uploader/dist/styles.css";
import axios from 'axios';
import { useSnackbar } from 'notistack';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

export default function ModalLogo({handleReload, isOpen, onClose, uuid}) {
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()
  const [uploadedFiles, setUploadedFiles] = useState([])
  const [logoUpload, setLogoUpload] = useState(null)

  const reset = () => {
              uploadedFiles.forEach(f => f.remove())
  }

  const MODAL_URL = "/clients";
  const config = {
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${getToken()}`
    },
  };

  const cleanData = async () => {
    setLogoUpload(null)
    reset();
  };

  
  const handleChangeStatus = ({meta, file, xhr, ...rest}, status) => {
    if (status !== "removed") {
      setLogoUpload(file);
    } else {
      setLogoUpload(null);
    }

    const fileRemove = rest.remove;

    setUploadedFiles(fids => [...fids, {
      name: file.name,
      remove: fileRemove
    }]);
  }
  
  const handleSubmit = async () => {
    setLoading(true);
    const exten = "."+logoUpload?.type.split("/").pop()
      
      config["params"] = {
        ext: exten,
        uuid: uuid
      }
  
      axiosBackend.get("logo", config).then( (response2) => {
        const fileForm = new FormData();
  
        Object.entries(response2.data.fields).forEach(([key, value]) => {
          fileForm.append(key, value);
        });
    
        fileForm.append("file", logoUpload);
    
        axios.post(response2.data.url, fileForm, {
          headers: {
            'Content-Type': 'multipart/form-data'
            }              
            }).then(function (response) {
            })
              .catch(function (error) {
            }).catch((err) => {

            if (err.data?.message) {
              enqueueSnackbar(err.data.message, { 
                variant: 'error'
              });
            } else {
              enqueueSnackbar('Falha ao fazer upload da imagem.', { 
                variant: 'error'
              });
            };
            });
            axiosBackend.post("logo", {}, config).then((result) => {
              enqueueSnackbar('Logo atualizada com sucesso.', { 
                variant: 'success'
              });
              handleReload();
              cleanData();
              onClose();
              setLoading(false);
          }).catch( (response_final) => {
            enqueueSnackbar('Falha ao fazer upload da imagem.', { 
              variant: 'error'
            })
            onClose();
            setLoading(false);
          })
      }).catch( (err) => {
        if (err.data?.message) {
          enqueueSnackbar(err.data.message, { 
            variant: 'error'
          });
        } else {
          enqueueSnackbar('Falha ao fazer upload da imagem.', { 
            variant: 'error'
          });
        };
        onClose();
        setLoading(false);
      });
  };

  return (
    <div className={`overlay ${isOpen ? 'open' : ''}`}>
      <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={loading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
      <div className={styles.draw_box}>
        <div className={styles.main_column}>
          <h1 className={styles.main_title}>Atualizar logo do cliente</h1>
          <div className={styles.main_row}>
            <div className={styles.main_row_item}>
              <Dropzone
              onChangeStatus={handleChangeStatus}
              maxFiles={1}
              multiple={false}
              canCancel={true}
              inputContent="Envie a imagem"
              accept="image/*"
              styles={{
                dropzone: { width: "100%", height: 112, overflow: "hidden", minHeight: 0 },
                inputLabel: { width: "100%", height: "100%", color: "#979797", fontFamily:"Inter" },
                preview: { width: "95%", height: "100%", minHeight: 0, padding: "0px 0px 0px 0px" },
                dropzoneActive: { borderColor: 'green' },
                previewImage: { objectFit: "cover", width: 137.725, height: 61, margin: "auto auto auto auto"},
              }}
            />
            </div>
          </div>
          <div className={styles.main_row}>
            <button className={styles.cancel_button} onClick={() => {
                cleanData();
                onClose();
              }}
            >
              Cancelar
            </button>
            <button
              disabled={!logoUpload ? true : false}
              className={styles.send_button}
              onClick={() => {
                handleSubmit();
              }}
            >
              Salvar
            </button>
          </div>
          
        </div>
      </div>
    </div>
  );
}